import { gql } from 'apollo-angular';

export const BUY_MOV_POINTS = gql`
  mutation ExtractBuyMovPoints($employeeId: String!) {
    extractBuyMovPoints(employeeId: $employeeId) {
      buyMovs {
        id
        status
        valuePoint
        buyDate
        employee {
          id
          name
        }
        buyItems {
          award {
            name
            value
          }
          quantity
          value
        }
      }
    }
  }
`;

export const SOLICITED_CANCEL_BUY_MOV = gql`
  mutation SolicitedCancelBuyMov($buyMovId: String!) {
    SolicitedCancelBuyMov(buyMovId: $buyMovId) {
      id
      status
    }
  }
`;
